import * as React from "react";
import { MemberPaymentErrors } from "shared/functions/memberPayments";

import Validator from "../../../../services/Validators/Validator";
import { IFormField } from "../../../../state/model/SharedTypes";
import CardPaymentForm from "./PaymentForm/PaymentForm";
// @ts-ignore
import Script from "react-load-script";
import Config from "src/services/Config/Config";

const authData = {
    clientKey : Config.authorizeKey(),
    apiLoginID : Config.authorizeApiID()
}

const CardPaymentErrors = {
    required: "*Required",
    invalidCardNumber: "*Invalid card number",
    invalidCardCode: "*Invalid CVV"
};

const MONTHS = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12"
];
const YEARS = ["2020", "2021", "2022", "2023", "2024", "2025", "2026", "2027","2028","2029"];

interface IProps {
    store: any;
    isPosting?: boolean;
    className?: string;
    paymentErrorCode?: string;
    paymentSucceeded?: boolean;
    isPaymentErrorFound?: boolean;
}

interface ILocalState {
    cardHolderName: IFormField<string>;
    cardNumber: IFormField<string>;
    cardCode: IFormField<string>;
    exiprationMonth: IFormField<string>;
    exiprationYear: IFormField<string>;
    isPosting: boolean
}

export default class PaymentFormContainer extends React.Component<
    IProps,
    ILocalState
    > {
    public state: ILocalState = {
        cardHolderName: {},
        cardNumber: {},
        cardCode: {},
        exiprationMonth: {
            data: MONTHS[0]
        },
        exiprationYear: {
            data: YEARS[0]
        },
        isPosting: false
    };

    public render() {
        const {
            cardNumber,
            cardCode,
            exiprationMonth,
            exiprationYear,
            cardHolderName,
            isPosting,
        } = this.state;
        const {className, store, isPaymentErrorFound} = this.props;
        return (
            <>
             <Script
                url={Config.authorizeLibURL()}
                onError={this.onScriptError}
                onLoad={this.onScriptLoaded}
            />
            <CardPaymentForm
                coworkDisplayName={"test cowork"}
                paymentAmount={"test amount"}
                cardHolderName={cardHolderName}
                onCardHolderNameChanged={this.onCardHolderNameChanged}
                cardNumber={cardNumber}
                onCardNumberChanged={this.onCardNumberChanged}
                cardCode={cardCode}
                onCardCodeChanged={this.onCardCodeChanged}
                expirationMonths={MONTHS}
                exiprationMonth={exiprationMonth}
                onExiprationMonthChanged={this.onExpirationMonthChanged}
                expirationYears={YEARS}
                exiprationYear={exiprationYear}
                onExiprationYearChanged={this.onExpirationYearChanged}
                onSubmitClicked={this.onSubmitClicked}
                errorMessage={this.errorMessage()}
                className={className}
                isPosting={Boolean(isPosting) && !Boolean(isPaymentErrorFound)}
                isFormFinished = {true}
                store={store}
            />
            </>
        );
    }

    private onScriptError() {
        console.error(`Failed loading authorize accept.js script`);
    }
    private onScriptLoaded() {
        return;
    }
    private errorMessage() {
        const { paymentErrorCode } = this.props;
        if (paymentErrorCode === MemberPaymentErrors.InvalidCreditCardDetails) {
            return "The card details are incorrect.";
        } else if (paymentErrorCode === MemberPaymentErrors.TransactionDeclined) {
            return "Transaction declined.";
        } else if (paymentErrorCode === MemberPaymentErrors.CardExpired) {
            return "This card had expired.";
        } else if (paymentErrorCode === MemberPaymentErrors.DuplicateTransaction) {
            return "A duplicate transaction has been submitted.";
        } else if (paymentErrorCode) {
            return "Failed completing payment.";
        } else {
            return undefined;
        }
    }

    private validateForm = () => {
        const {
            cardNumber,
            cardCode,
            cardHolderName
        } = this.state;

        let isValidForm = true;
        const updatedState = {
            ...this.state
        };

        if (!cardHolderName.data || cardHolderName.data.length <= 2) {
            updatedState.cardHolderName.error = CardPaymentErrors.required;
            isValidForm = false;
        } else {
            updatedState.cardHolderName.error = undefined;
        }

        const filteredCardNumber = Validator.filterCardNumber(cardNumber.data);
        if (!cardNumber.data || cardNumber.data.length === 0) {
            updatedState.cardNumber.error = CardPaymentErrors.required;
            isValidForm = false;
        } else if (!Validator.isValidCardNumber(filteredCardNumber)) {
            updatedState.cardNumber.error = CardPaymentErrors.invalidCardNumber;
            isValidForm = false;
        } else {
            updatedState.cardNumber.error = undefined;
        }

        if (!cardCode.data || cardCode.data.length === 0) {
            updatedState.cardCode.error = CardPaymentErrors.required;
            isValidForm = false;
        } else if (!Validator.isValidCardCode(cardCode.data)) {
            updatedState.cardCode.error = CardPaymentErrors.invalidCardCode;
            isValidForm = false;
        } else {
            updatedState.cardCode.error = undefined;
        }
        this.setState(updatedState);
        return isValidForm
    };

    private onSubmitClicked = () => {
        const {
            cardNumber,
            cardCode,
            cardHolderName,
            exiprationMonth,
            exiprationYear,
        } = this.state;
        const {store} = this.props;
        store.paymentError = false;
        if (this.validateForm()) {
            const newState = this.state;
            newState.isPosting = true;
            this.setState(newState);
            try {
                if (!cardNumber.data) {
                    throw new Error(`Invalid Card number`);
                }
                const cardData = {
                    fullName: cardHolderName.data,
                    cardNumber: cardNumber.data.trim().split(" ").join(""),
                    month: exiprationMonth.data,
                    year: exiprationYear.data,
                    cardCode: cardCode.data
                };
                const secureData = {
                    authData,
                    cardData
                };
                (window as any).Accept.dispatchData(secureData, this.onAuthorizeResponse);
            } catch (err) {
                const errorMessage = `Failed posting member payment ${err} }`;
                console.error(errorMessage);
            }
        }
    };
    private onAuthorizeResponse = async (res: any) => {
        const {store} = this.props;
        store.paymentError = false;
        if (res.messages.resultCode === 'Error') {
            store.paymentError = res.messages.message[0].text;
        } else {
            await store.updatePayment(res.opaqueData);
        }
        const newState = this.state;
        newState.isPosting = false;
        this.setState(newState);
    };

    private onCardHolderNameChanged = (name: string) => {
        const {store} = this.props;
        store.formInput.payment.cardHolderName = name;
        this.setState({ cardHolderName: { data: name } });
    };

    private onCardNumberChanged = (num: string) => {
        const {store} = this.props;
        store.formInput.payment.cardNumber = num;
        this.setState({ cardNumber: { data: num } });
    };

    private onCardCodeChanged = (num: string) => {
        const {store} = this.props;
        store.formInput.payment.cardCode = num;
        this.setState({ cardCode: { data: num } });
    };

    private onExpirationMonthChanged = (name: string) => {
        const {store} = this.props;
        store.formInput.payment.exiprationMonth = name;
        this.setState({ exiprationMonth: { data: name } });
    };

    private onExpirationYearChanged = (name: string) => {
        const {store} = this.props;
        store.formInput.payment.exiprationYear = name;
        this.setState({ exiprationYear: { data: name } });
    };
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/components/PaymentFormContainer/PaymentFormContainer.tsx